import React from 'react';
import { Button } from 'react-bootstrap';
import RoleUtils from './roleUtils';
const ApproveBtn = (onClickHandler) => <Button key="A" className="vActionBtn right" id="approveBtn" onClick={onClickHandler}>Approve</Button>;
const RejectBtn = (onClickHandler) => <Button key="R" className="vActionBtn right" id="rejectBtn" onClick={onClickHandler}>Reject</Button>;
const PendingClientBtn = (onClickHandler) => <Button key="P" className="vActionBtn right" id="pendingClientBtn" onClick={onClickHandler}>Pending Client</Button>;
const ReSubmitBtn = (onClickHandler) => <Button key="S" className="vActionBtn right" id="resubmitBtn" onClick={onClickHandler}>Resubmit</Button>;
const InProcessBtn = (onClickHandler) => <Button key="I" className="vActionBtn right" id="inprocessBtn" onClick={onClickHandler}>In Process</Button>;
const CancelBtn = (onClickHandler) => <Button key="C" className="vActionBtn right" id="cancelBtn" onClick={onClickHandler}>Cancel Request</Button>;
const SubmitEWBtn = (onClickHandler) => <Button key="E" className="vActionBtn right" id="submitEWBtn" onClick={onClickHandler}>Submit Early Warning</Button>;
const ResubmitEWBtn = (onClickHandler) => <Button key="W" className="vActionBtn right" id="resubmitEWBtn" onClick={onClickHandler}>Resubmit Early Warning</Button>;
const RequestUtils = {
    determineRequestStatus: function (statusId) {
        switch (statusId) {
            case 1:
                return 'NEW';
            case 2:
                return 'APPROVED';
            case 3:
                return 'PENDING CLIENT';
            case 4:
                return 'IN PROCESS';
            case 5:
                return 'REJECTED';
            case 6:
                return 'AUTO CLOSED';
            case 7:
                return 'CANCELLED';
            case 8:
                return 'PENDING EARLY WARNING';
            default:
                return 'UNKNOWN';
        }
    },
    // DE786769 Wrong Request Type & Status - changed to update and add to enroll
    determineRequestType: function (requestType) {
        switch (requestType) {
            case 0:
                return 'NA';
            case 1:
                return 'CANCEL';
            case 2:
                return 'ENROLL';
            case 3:
                return 'UPDATE';
            default:
                return '';
        }
    },

    getRequestActionButtons: function (statusId, isAdmin, hasWLRole, onClickHandler, showSubmitEWButton, showResubmitEWButton) {
        var btnArr = [];
        switch (statusId) {
            case 1:  //NEW
                if (isAdmin) {
                    btnArr.push(ApproveBtn(onClickHandler));
                    btnArr.push(InProcessBtn(onClickHandler));
                    btnArr.push(PendingClientBtn(onClickHandler));
                    btnArr.push(RejectBtn(onClickHandler));
                    if (showResubmitEWButton) {
                        btnArr.push(ResubmitEWBtn(onClickHandler));
                    }
                }
                else if (hasWLRole) {
                    btnArr.push(CancelBtn(onClickHandler));
                }
                else { }
                break;
            case 2:     //'APPROVED'
               //No Buttons
                break;
            case 3:     //'PENDING CLIENT'             
                if (isAdmin) {
                    btnArr.push(ApproveBtn(onClickHandler));
                    btnArr.push(InProcessBtn(onClickHandler));
                    btnArr.push(RejectBtn(onClickHandler));
                    if (showResubmitEWButton) {
                        btnArr.push(ResubmitEWBtn(onClickHandler));
                    }
                }
                else if (hasWLRole) {
                    btnArr.push(ReSubmitBtn(onClickHandler));
                    btnArr.push(CancelBtn(onClickHandler));
                }
                else { }
                break;
            case 4: //'IN PROCESS'
                if (isAdmin) {
                    btnArr.push(ApproveBtn(onClickHandler));
                    btnArr.push(PendingClientBtn(onClickHandler));
                    btnArr.push(RejectBtn(onClickHandler));
                    if (showResubmitEWButton) {
                        btnArr.push(ResubmitEWBtn(onClickHandler));
                    }
                }
                else if (hasWLRole) {
                    btnArr.push(CancelBtn(onClickHandler));
                }
                else { }
                break;
            case 5:  //'REJECTED'
                //NO BUTTONS
                break;
            case 6:  //'AUTO CLOSED'
                //NO BUTTONS
                break;
            case 8:  // PENDING EARLY WARNING
                if (isAdmin) {
                    btnArr.push(RejectBtn(onClickHandler));
                    if (showSubmitEWButton) {
                        btnArr.push(SubmitEWBtn(onClickHandler));
                    }
                }
                else if (hasWLRole) {
                    btnArr.push(CancelBtn(onClickHandler));
                }
                else { }
                break;
            default:
                console.log(`Invalid Request Status passed in ${statusId}`);
                break;
        }
        return btnArr;
    },

    getSortedEarlyWarningCalls: function (bankRequest) {
        if (!bankRequest) return [];

        const ewCalls = bankRequest.earlyWarningCalls || [];
        const ewScoreFromBankRequest = bankRequest.earlyWarningScore;
        const ewResponseFromBankRequest = bankRequest.earlyWarningResponse;

        const parseJSON = (jsonString) => {
            try {
                return jsonString ? JSON.parse(jsonString) : null;
            } catch (error) {
                console.error("Failed to parse JSON:", error);
                return null; 
            }
        };

        const combinedEwCalls = [
            ...(ewScoreFromBankRequest !== undefined && ewScoreFromBankRequest !== ""
                ? [{
                    earlyWarningCallId: null, 
                    vendorBankRequestId: bankRequest.vendorBankRequestId,
                    earlyWarningScore: ewScoreFromBankRequest,
                    earlyWarningRequest: null, 
                    earlyWarningResponse: parseJSON(ewResponseFromBankRequest),
                    earlyWarningRequestTypeId: null, 
                    timestamp: bankRequest.createdDt
                }]
                : []),
            ...ewCalls.map(call => ({
                earlyWarningCallId: call.earlyWarningCallId,
                vendorBankRequestId: call.vendorBankRequestId,
                earlyWarningScore: call.earlyWarningScore,
                earlyWarningRequest: parseJSON(call.earlyWarningRequest), 
                earlyWarningResponse: parseJSON(call.earlyWarningResponse), 
                earlyWarningRequestTypeId: call.earlyWarningRequestTypeId,
                timestamp: call.createdDt
            }))
        ];

        const sortedEwCalls = combinedEwCalls.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

        return sortedEwCalls; 
    },

    getMostRecentEarlyWarningScoreAndCall: function (bankRequest) {
        if (!bankRequest) return { mostRecentCall: null, mostRecentScore: null };

        const sortedCalls = RequestUtils.getSortedEarlyWarningCalls(bankRequest);
        const mostRecentCall = sortedCalls[0]; 
        const mostRecentScore = mostRecentCall?.earlyWarningScore ?? null; 

        return { mostRecentCall, mostRecentScore };
    },

    checkCommentsAndAttachmentsPerms: function (statusId, currentUser, currentCompanyId){
        var isApWorklist = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumWorklistOnlyRole());
        var isSupplierEditBank =  RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditBankRoles())
        //If (new or in process AND has AP_worklist role) OR (If pending client AND has supplier edit bank role)
        if (((statusId === 1 || statusId === 4) && isApWorklist) || (statusId === 3 && isSupplierEditBank)) {
            return true;
          } 
        return false;
    }, 
    checkDeleteAttachmentsPerms: function (statusId, currentUser, currentCompanyId){
        var isApWorklist = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumWorklistOnlyRole());
        //If (new or in process AND has AP_worklist role)
        return (((statusId === 1 || statusId === 4) && isApWorklist)); 
    }, 
    createAttachmentInfo: function (requestData, vendorID) {
        var fType = (requestData.attachCheck === true) ? 2 : 1;
        let attachInfo = new FormData();
        attachInfo.append('attachmentType', fType);
        attachInfo.append('attachedFile', requestData.attachFile);
        attachInfo.append('fileType', requestData.attachFile.type.toUpperCase());
        attachInfo.append('fileSize', requestData.attachFile.size);
        attachInfo.append('submitterContactId', requestData.submitterContactId);
        attachInfo.append('vendorRecordId', vendorID);
        return attachInfo;
    },
    validateRoutingNumber: function (routingNumberToTest) {
        if (!routingNumberToTest) { //Nothing entered
            return false;
        }

        var routing = routingNumberToTest.toString();
        while (routing.length < 9) {
            routing = '0' + routing; //I refuse to import left-pad for this
        }

        if (routing === "000000000") {//all 0's is technically a valid routing number, but it's inactive
            return false;
        }

        //gotta be 9  digits
        var match = routing.match("^\\d{9}$");
        if (!match) {
            return false;
        }

        //The first two digits of the nine digit RTN must be in the ranges 00 through 12, 21 through 32, 61 through 72, or 80.
        //https://en.wikipedia.org/wiki/Routing_transit_number
        const firstTwo = parseInt(routing.substring(0, 2));
        const firstTwoValid = (0 <= firstTwo && firstTwo <= 12)
            || (21 <= firstTwo && firstTwo <= 32)
            || (61 <= firstTwo && firstTwo <= 72)
            || firstTwo === 80;
        if (!firstTwoValid) {
            return false;
        }

        //this is the checksum
        //http://www.siccolo.com/Articles/SQLScripts/how-to-create-sql-to-calculate-routing-check-digit.html
        const weights = [3, 7, 1];
        var sum = 0;
        for (var i = 0; i < 8; i++) {
            sum += parseInt(routing[i]) * weights[i % 3];
        }

        return (10 - (sum % 10)) % 10 === parseInt(routing[8]);
    },
    getColor: function (value) {  
            return value >= 97 ? '#00B050' : value === 'N/A' ? 'black' : value <= 96 ? 'red' : 'black';  
    },
    maskString: str => (str.length < 3) ? "" : "*".repeat(str.length - 3) + str.slice(-3),
    maskTINString: str => (str.length < 4) ? "" : "*".repeat(str.length - 4) + str.slice(-4)

}
export default RequestUtils;